import { combineReducers } from 'redux';
import editHoraProjeto from './editHoraProjeto';
import colaboradores from './sendProjCol';

export default combineReducers({
    editHoraProjeto,
    colaboradores,
});